export const SET_THEME = 'SET_THEME'
export const SET_ALERT = 'SET_ALERT'
export const SET_PAGE_TITLE = 'SET_PAGE_TITLE'
export const SET_LOADING = 'SET_LOADING'
export const SET_SIDEBAR = 'SET_SIDEBAR'
export const SET_ANIMATE = 'SET_ANIMATE'
export const SET_LANGUAGE = 'SET_LANGUAGE'
export const SET_HIDE = 'SET_HIDE'